import { CartScreen } from 'features/cart/cart-screen';
import { useCartRecoveryMode } from 'features/cart/hooks/use-cart-recovery-mode';
import { useDiagnosticContributor } from 'features/diagnostics/context/provider';

import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';
import { Cart } from 'pages/cart/cart';

export default function CartPage() {
  useExposeMinimalCartExperiment();
  useDiagnosticContributor('cart-surface', () => null);
  const { mode, isResolving } = useCartRecoveryMode({ logRecoveryOverride: true });

  // Don't evaluate the empty-cart menu redirect until cart recovery is resolved. While experiments
  // load, `mode` can transiently be `legacy`; redirecting then would bounce a minimal-cart user to
  // the menu before their cart hydrates.
  const shouldEvaluateCartRedirect = !isResolving;

  if (mode === 'minimal') {
    return <CartScreen shouldEvaluateCartRedirect={shouldEvaluateCartRedirect} />;
  }

  return <Cart shouldEvaluateCartRedirect={shouldEvaluateCartRedirect} />;
}
